var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insight-chart"},[_c('canvas',{ref:"chartCanvas",attrs:{"height":_vm.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }